import EmployeeInfoGeneralInfoComponent from "../components/EmployeeInfoGeneralInfo";
import useEmployeeGeneralInfo from "../hooks/useEmployeeGeneralInfo";

function EmployeeInfoGeneralInfo(props) {
  const useEmployeeGeneralInfoProps = useEmployeeGeneralInfo();

  return <EmployeeInfoGeneralInfoComponent {...useEmployeeGeneralInfoProps} {...props} />;
}

export default EmployeeInfoGeneralInfo;
